import { render, staticRenderFns } from "./ItemListCreationLayout.vue?vue&type=template&id=81527016&scoped=true&"
import script from "./ItemListCreationLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListCreationLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81527016",
  null
  
)

export default component.exports